import {
  isAddendumBackPayItem,
  isBackPayItem,
} from "../../helper-payroll/constants/payrollConstants";

export const getHeader = (selected, deductions) => {
  const { payrollTypes, jobTypeVal, payItems } = selected;
  const { additionalType, contributionType, deductionType } = deductions;
  const isBackPay = isBackPayItem(payItems);
  const isAddendumBackPay = isAddendumBackPayItem(payItems);

  const BasicPayGPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "OVERPAYMENT (BASIC)" },
    { rowSpan: 2, label: "OVERPAYMENT (PERA ADA)" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
    // { rowSpan: 2, label: "Email" },
  ];
  const BasicPayGPSubheaders = [
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];
  const BasicPayAPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA" },
    { rowSpan: 2, label: "DATE OF ABSENCES" },
    { rowSpan: 2, label: "LEAVE WITHOUT PAY DATES" },
    { rowSpan: 2, label: "DATE OF HALF DAYS" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const BasicPayAPSubheaders = [
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];

  const BasicPayBPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    { rowSpan: 2, label: "DAYS IN A MONTH" },
    { rowSpan: 2, label: "DATES OF ABSENCE" },
    { rowSpan: 2, label: "LEAVE WITHOUT PAY DATES" },
    { rowSpan: 2, label: "DATES OF HALF DAY" },
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "HALF DAYS TO BE DEDUCTED" },
    { rowSpan: 2, label: "MINUTES TO BE DEDUCTED" },
    { rowSpan: 2, label: "GSIS INSURED DAYS" },
    { colSpan: 1, label: "PERIOD COVERED" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    { rowSpan: 2, label: "PERA/ADA" },
    { rowSpan: 2, label: "BASIC RATE FOR BACK-PAY" },
    { rowSpan: 2, label: "PERA/ADA FOR BACK-PAY" },
    { colSpan: 4, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "EARNED (BASIC)" },
    { rowSpan: 2, label: "EARNED (PERA ADA)" },
    ...(contributionType.length > 0
      ? [
          {
            colSpan: contributionType.length + 1,
            label: "MANDATORY DEDUCTIONS",
          },
        ]
      : []),
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const BasicPayBPSubheaders = [
    // "MONTH",
    // "YEAR",
    "DATE",
    "DEDUCTIONS DUE TO LEAVES, ABSENCES AND TARDINESS(BASIC)",
    "DEDUCTION (PERA/ADA)",
    "OVERPAYMENT (BASIC)",
    "OVERPAYMENT (PERA ADA)",
    "Tax",
    ...contributionType,
    ...deductionType,
    ...additionalType,
  ];

  const AugmentationPayGPAPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    ...(isBackPay
      ? [{ rowSpan: 2, label: "YEAR" }]
      : []),
    ...(isBackPay
      ? [{ rowSpan: 2, label: "MONTH" }]
      : []),
    ...(isBackPay
      ? [{ colSpan: 1, label: "PERIOD COVERED" }]
      : []),
      {
        colSpan: 5,
        label: "PRESENT ASSIGNMENT",
      },
    {
      colSpan: 5,
      label: "AUGMENTATION(T1, T3, CIA, MCIA, & DIA)",
    },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCT NO." },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "AP RATE" },
    ...(isBackPay
      ? [{ rowSpan: 2, label: "RATE PER DAY" }]
      : []),
    { colSpan: 5, label: "CURRENT ASSIGNMENT" },
    { colSpan: 5, label: "AIRPORT AUGMENTATION" },
    { rowSpan: 2, label: "EXCESS AIRPORT DUTIES" },
    { rowSpan: 2, label: "TOTAL EARNED" },
    { colSpan: 2, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "DATES OF FLAG RAISING" },
    { rowSpan: 2, label: "NET EARNED" },
    { rowSpan: 2, label: "TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET AMOUNT" },
  ];

  const AugmentationPayGPAPSubheaders = [
    ...(isBackPay ? ["DATE"] : []),
    "Y=24/7 N=7:00-5:30",
    "# of duty for CIA/MCIA/BINOC (Range to 15-19)",
    "ABS",
    "Date of Absences/Leave",
    "LATES/ UT",
    "# of duty for CIA/MCIA/BINOC (Range to 15-19)",
    "NO.OF DUTIES",
    "ABS",
    "Augmentation Date of Absences",
    "LATES/UT",
    "TOTAL DAYS DUTY",
    "PRORATED AP RATE",
    "ABSENCES/LEAVES",
    "LATES/ UT",
    "EARNED CURRENT ASSIGNMENT",
    "AIRPORT AUGMENTATION RATE",
    "AMOUNT EARNED AIRPORT AUGMENTATION",
    "ABSENCES/LEAVES",
    "LATES/ UT",
    "EARNED AIRPORT DUTIES",
    "OVERPAYMENT",
    "FLAG RAISING",
    ...deductionType,
    ...additionalType,
  ];

  const joBPHeaders = [
    { rowSpan: 2, label: "SEQUENCE" },
    ...(jobTypeVal === "Job Order" && isBackPay
      ? [{ rowSpan: 2, label: "YEAR" }]
      : []),
    ...(jobTypeVal === "Job Order" && isBackPay
      ? [{ rowSpan: 2, label: "MONTH" }]
      : []),
    ...(jobTypeVal === "Job Order" && isBackPay
      ? [{ colSpan: 1, label: "PERIOD COVERED" }]
      : []),
    { rowSpan: 2, label: "NO.OF DAYS" },
    { rowSpan: 2, label: "EMPLOYEE NUMBER" },
    { rowSpan: 2, label: "ACCOUNT NUMBER" },
    { rowSpan: 2, label: "LAST NAME" },
    { rowSpan: 2, label: "FIRST NAME" },
    { rowSpan: 2, label: "MIDDLE NAME" },
    { rowSpan: 2, label: "BASIC" },
    ...(jobTypeVal === "Job Order" && !isBackPay
      ? [{ rowSpan: 2, label: "DATE OF ABSENCES" }]
      : []),
    ...(jobTypeVal === "Job Order" && isBackPay
      ? [{ rowSpan: 2, label: "BASIC RATE FOR BACK-PAY" }]
      : []),
    { rowSpan: 2, label: "DAYS TO BE DEDUCTED" },
    ...(jobTypeVal === "Job Order" && isBackPay
      ? [{ rowSpan: 2, label: "DATES OF ABSENCE" }]
      : []),
    { rowSpan: 2, label: "MINS TO BE DEDUCTED" },
    { colSpan: 5, label: "DEDUCTIONS BEFORE TAX" },
    { rowSpan: 2, label: "DATES OF FLAG RAISING" },
    { colSpan: 5, label: "WITHHOLDING TAX" },
    ...(deductionType.length > 0
      ? [
          {
            colSpan: deductionType.length,
            label: "LOANS AND OTHER DEDUCTIONS",
          },
        ]
      : []),
    ...(additionalType.length > 0
      ? [{ colSpan: additionalType.length, label: "OTHER ADDITIONAL" }]
      : []),
    { rowSpan: 2, label: "NET PAY" },
  ];

  const joBPSubHeaders = [
    ...(jobTypeVal === "Job Order" && isBackPay
      ? ["DATE"]
      : []),
    "ABSENCES DAYS",
    "ABSENCES MINS",
    "OVERPAYMENT",
    "FLAG RAISING",
    "EARNED FOR THE PERIOD",
    "3%",
    "2%",
    "5%",
    "10%",
    "TOTAL TAX",
    ...deductionType,
    ...additionalType,
  ];

  switch (true) {
    case payrollTypes === "BP" && payItems === "General Payroll":
      return [BasicPayGPHeaders, BasicPayGPSubheaders];
    case payrollTypes === "BP" &&
      jobTypeVal !== "Job Order" &&
      payItems === "Addendum Payroll":
      return [BasicPayAPHeaders, BasicPayAPSubheaders];
    case payrollTypes === "BP" && isAddendumBackPay:
      return [BasicPayBPHeaders, BasicPayBPSubheaders];
    case payrollTypes === "AP" &&
      (payItems === "General Payroll" ||
        payItems === "Newly-Hired" ||
        isBackPay):
      return [AugmentationPayGPAPHeaders, AugmentationPayGPAPSubheaders];
    case payrollTypes === "BP" && jobTypeVal === "Job Order":
      return [joBPHeaders, joBPSubHeaders];
    default:
      return [[], [], []];
  }
};
